import React, { useState, useEffect } from 'react';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import Button from '../Button';
import ModalContainer from '../ModalContainer';
import CenterModal from '../Modal/CenterModal';
import AgentSuccessModal from '../AgentSuccessModal';
import Loaders from '../Loaders';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../Context/authContext';
import Toast from '../Toast';
import CreatTeamModal from '../CreatTeamModal';
import TeamCard from '../TeamCard';
import { AgentsSectionStyled, PageHeader, AgentCardHolder } from './TeamSection.styles';
import teamService from '../../services/teamService';
import DiscoverTeamSection from './DiscoverTeamSection';
import Field from '../Field';
import { useQuery } from '@tanstack/react-query';

const TeamSection = () => {
  const [filterName, setFilterName] = useState(null);
  const [successModal, setSuccessModal] = useState(false);
  const [activeTab, setActiveTab] = useState('my-agents');
  const { fetch, refetch, user } = useContextHook(AuthContext, v => ({
    fetch: v.fetch,
    refetch: v.refetch,
    user: v.user,
  }));
  const searchQuery = user?.data?.ID;

  const getAllTeamsData = useQuery({
    queryKey: ['teams'],
    queryFn: () => teamService.getAllTeam(searchQuery),
    staleTime: Infinity,
  });

  function teamLimit() {
    Toast({
      type: 'info',
      message: 'Team limit exceed',
    });
  }
  return (
    <>
      <CenterModal width="500" title="Team Created!" open={successModal} setOpen={setSuccessModal}>
        <AgentSuccessModal desc="Congratulations, your team is active successfully, you can start using it." />
      </CenterModal>
      <AgentsSectionStyled>
        <PageHeader>
          <div className="text-box">
            <h1>Team</h1>
            <p>Create and explore custom AI Team with tailored instructions and diverse skills.</p>
          </div>
          <ModalContainer
            width="1000"
            title="Create New Team"
            content={({ onClose }) => (
              <CreatTeamModal setSuccessModal={setSuccessModal} onClose={onClose} refetch={refetch} />
            )}
            btnComponent={({ onClick }) => (
              <Button
                variant="secondary"
                width="160px"
                onClick={getAllTeamsData?.data?.teams?.length >= user?.plan?.team_creation_limit ? teamLimit : onClick}>
                <AiOutlinePlusCircle size="18" /> Create Team
              </Button>
            )}
          />
        </PageHeader>
        <ul className="filter-list">
          <li>
            <button
              className={`btn-filter ${activeTab === 'my-agents' ? 'active' : ''}`}
              type="button"
              onClick={() => setActiveTab('my-agents')}>
              my team
            </button>
          </li>
          <li>
            <button
              className={`btn-filter ${activeTab === 'feeda-agents' ? 'active' : ''}`}
              type="button"
              onClick={() => setActiveTab('feeda-agents')}>
              discover
            </button>
          </li>
        </ul>

        {/* Show only the active section */}
        {activeTab === 'my-agents' && (
          <div className="my-agents">
            <div className="input-wrapper">
              <Field
                type="text"
                placeholder="Search team by name"
                name="searchAgent"
                onChange={({ target }) => setFilterName(target?.value)}
              />
            </div>
            <AgentCardHolder>
              {getAllTeamsData?.isPending ? (
                <Loaders viewLoader />
              ) : (
                <TeamCard
                  teamCardsData={getAllTeamsData?.data?.teams}
                  removeDelete={true}
                  aiAgents={false}
                  refetch={refetch}
                  filterName={filterName}
                  setSuccessModal={setSuccessModal}
                />
              )}
            </AgentCardHolder>
          </div>
        )}
        {activeTab === 'feeda-agents' && <DiscoverTeamSection />}
      </AgentsSectionStyled>
    </>
  );
};

export default TeamSection;
